import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  categoriesDropdownNoIconStyle,
  selectFieldStyleSmall,
} from "../../../assets/scss/style";
import {
  buttonNameConstants,
  buttonTypeConstants,
  categoryDropdownConstants,
  defaultGridStateDataTable,
  EMPTY_STRING,
  globalConstants,
  inventoryConstants,
  routesPathConstants,
  toolTipMessages,
} from "../../../constants";
import { TABLE_IDS } from "../../../constants";
import { inventoryActions } from "../../../redux/actions";
import {
  Topbar,
  ProgressBar,
  SearchField,
  TitleToolTip,
  SimpleTextArea,
  SelectDropDown,
  DataTableComponent,
  CategoriesDropdown,
  SimpleInputTextField,
  Button,
} from "../../../shared/components";
import {
  getConfirmAuditCompletionHtml,
  getConfirmAuditCompletionHtmlShopify,
  getConfirmAuditCompletionHtmlTitle,
  getConfirmAuditCompletionIncompleteHtml,
  getConfirmAuditCompletionIncompleteHtmlTitle,
  getStockAuditCategoriesColumns,
  getConfirmCategoryCompletionIncompleteHtml,
  getConfirmCategoryCompletionIncompleteHtmlTitle,
  getConfirmCategoryCompletionHtml,
  getConfirmCategoryCompletionHtmlTitle,
} from "../../../shared/utilities/columnHeadersUtility/stockAudit";
import ConfirmationModal from "../../../views/Inventory/Items/ConfirmationModal/ConfirmationModal";
import {
  BlueBoxIcon,
  CrossIcon,
  EditIcon,
  SearchIcon,
  TickIcon,
} from "../../../assets/icons/iconsProvider";
import {
  calculateBarWidth,
  getDurationString,
  getReceiptPrintDate,
  isShopifyConnected,
  isSpinnerEnabled,
  LoadingIndicatorLarge,
  parseToThousandSeperatorWholeNumber,
} from "../../../shared/utility";

const StockAuditSession = (props) => {
  const {
    user,
    stockAudit,
    spinnerArray,
    currentStore,
    updateAuditSession,
    stockAuditCategoryList,
    getStockAuditCategories,
    updateStockAuditCategory,
  } = props;

  const { state } = useLocation();
  const navigate = useNavigate();
  let numOfRenders = useRef(0);

  const auditSession = state?.currentAudit;
  const [isCompleteConfirmationModal, setIsCompleteConfirmationModal] =
    useState(false);
  const [isCancelConfirmationModal, setIsCancelConfirmationModal] =
    useState(false);
  const [gridState, setGridState] = useState(defaultGridStateDataTable);
  const [notes, setNotes] = useState(auditSession.notes || "");
  const [nickName, setNickName] = useState(auditSession.nickName || "");
  const [isEditNickName, setIsEditNickName] = useState(false);
  const [isEditNotes, setIsEditNotes] = useState(false);
  const [allCategoriesCompleted, setAllCategoriesCompleted] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filterStatus, setFilterStatus] = useState(
    inventoryConstants.STOCK_AUDIT_DEFAULT_FILTER_STATUS_OPTION
  );
  const [filterType, setFilterType] = useState(
    inventoryConstants.STOCK_AUDIT_DEFAULT_FILTER_STATUS_OPTION
  );
  const [defaultSortFieldId, setDefaultSortFieldId] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [isBulkCompleteConfirmationModal, setIsBulkCompleteConfirmationModal] =
    useState(false);
  const [isBulkConfirmCompleteModal, setIsBulkConfirmCompleteModal] =
    useState(false);
  const [bulkUncountedAction, setBulkUncountedAction] = useState(null);

  const handleOpenClick = useCallback(
    (row) => {
      updateStockAuditCategory(
        currentStore?.id,
        auditSession?.id,
        {
          items: [
            {
              ...row,
              isLocked: true,
              lockUser: `${user.firstName} ${user.lastName}`,
              lockedAt: moment().toISOString(),
              status:
                row.status === buttonNameConstants.NOT_STARTED
                  ? buttonNameConstants.IN_PROGRESS
                  : row.status,
              startedBy: row.startedBy ?? `${user.firstName} ${user.lastName}`,
              startDate: row.startDate ?? new Date(),
            },
          ],
        },
        inventoryConstants.LOCK,
        navigate,
        state
      );
    },
    // eslint-disable-next-line
    [currentStore]
  );

  const [columns, setColumns] = useState(
    getStockAuditCategoriesColumns(handleOpenClick)
  );

  useEffect(() => {
    setColumns(getStockAuditCategoriesColumns(handleOpenClick));
  }, [handleOpenClick]);

  const clearSearchText = () => {
    setSearchText((prev) => EMPTY_STRING);
  };

  //-------Handle searchfield or filters change
  const handleFilterData = (e) => {
    let filterList = sortedGridData;
    if (searchText) {
      filterList = filterList.filter((row) => {
        return (
          String(row.categoryName + row.productTypeName)
            .toLowerCase()
            .includes(String(searchText).toLowerCase()) &&
          searchText !== EMPTY_STRING
        );
      });
    }
    if (filterStatus.label !== globalConstants.ALL) {
      filterList = filterList.filter((row) => {
        return row.status === filterStatus.value;
      });
    }
    if (filterType.label !== globalConstants.ALL) {
      filterList = filterList.filter((row) => {
        return row.productTypeName === filterType.value;
      });
    }
    return filterList;
  };
  const handleRowSelectionChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  const toggleBulkCompleteConfirmationModal = () => {
    setIsBulkCompleteConfirmationModal(!isBulkCompleteConfirmationModal);
  };

  const handleBulkCompleteConfirmNoButtonClick = () => {
    toggleBulkCompleteConfirmationModal();
  };

  const handleBulkComplete = (uncountedAction) => {
    const categoryIds = selectedRows
      .filter((row) => row?.id)
      .map((row) => row.id);
    if (!categoryIds.length) return;
    updateStockAuditCategory(
      currentStore?.id,
      auditSession?.id,
      { categoryIds, uncountedAction: uncountedAction || undefined },
      buttonNameConstants.COMPLETED,
      null,
      null,
      false
    );
    setSelectedRows([]);
  };

  const handleMarkSelectedAsCompleted = () => {
    if (!selectedRows.filter((row) => row?.id).length) return;
    const hasUncountedItems = selectedRows.some(
      (row) => (row.itemsAudited || 0) < (row.totalItems || 0)
    );
    if (hasUncountedItems) {
      toggleBulkCompleteConfirmationModal();
    } else {
      setBulkUncountedAction(null);
      toggleBulkConfirmCompleteModal();
    }
  };

  const toggleBulkConfirmCompleteModal = () => {
    setIsBulkConfirmCompleteModal(!isBulkConfirmCompleteModal);
  };

  const handleBulkConfirmCompleteNoButtonClick = () => {
    toggleBulkConfirmCompleteModal();
  };

  const handleBulkConfirmCompleteYesButtonClick = () => {
    handleBulkComplete(bulkUncountedAction);
    toggleBulkConfirmCompleteModal();
  };

  const handleMarkSelectedAsInProgress = () => {
    const items = selectedRows.map((row) => ({
      ...row,
      status: buttonNameConstants.IN_PROGRESS,
      startedBy: row.startedBy ?? `${user.firstName} ${user.lastName}`,
      startDate: row.startDate ?? new Date(),
    }));
    if (!items.length) return;
    updateStockAuditCategory(
      currentStore?.id,
      auditSession?.id,
      { items },
      EMPTY_STRING,
      null,
      null
    );
    setSelectedRows([]);
  };

  const gridData = useMemo(() => {
    setAllCategoriesCompleted(
      !stockAuditCategoryList?.stockAuditItemOrganization?.some(
        (item) => item.status !== buttonNameConstants.COMPLETED
      )
    );
    numOfRenders.current++;
    return stockAuditCategoryList?.stockAuditItemOrganization || [];
  }, [stockAuditCategoryList]);

  const sortedGridData = useMemo(() => {
    if (!gridState.sortBy?.length) return gridData;

    const { id, desc } = gridState.sortBy[0];

    return [...gridData].sort((a, b) => {
      const aVal = a[id];
      const bVal = b[id];

      if (aVal == null) return 1;
      if (bVal == null) return -1;

      if (typeof aVal === "string") {
        return desc ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
      }

      return desc ? bVal - aVal : aVal - bVal;
    });
  }, [gridData, gridState.sortBy]);

  const isInitializingAudit = useMemo(() => {
    const audit = stockAudit?.auditData?.find(
      (item) => item.id === auditSession?.id
    );

    return audit?.isInitializingAudit ?? false;
  }, [auditSession?.id, stockAudit?.auditData]);

  useEffect(() => {
    getStockAuditCategories(currentStore?.id, auditSession?.id);
    numOfRenders.current++;
    // eslint-disable-next-line
  }, [isInitializingAudit, currentStore]);

  // change the status
  const handleChange = (e) => {
    if (e.value === buttonNameConstants.COMPLETED) {
      toggleCompleteConfirmationModal();
    } else {
      toggleCancelConfirmationModal();
    }
  };

  //When you click on complete the audit session
  const toggleCompleteConfirmationModal = () => {
    setIsCompleteConfirmationModal(!isCompleteConfirmationModal);
  };
  //When you click on complete the audit session clicking no
  const handleCompleteConfirmNoButtonClick = () => {
    toggleCompleteConfirmationModal();
  };
  //When you click on complete the audit session clicking yes
  const handleCompleteConfirmYesButtonClick = () => {
    updateAuditSession(
      currentStore?.id,
      {
        ...auditSession,
        status: buttonNameConstants.COMPLETED,
        completedBy: `${user.firstName} ${user.lastName}`,
        endDate: new Date(),
      },
      buttonNameConstants.COMPLETED,
      navigate
    );
  };

  //When you click on cancel the audit session
  const toggleCancelConfirmationModal = () => {
    setIsCancelConfirmationModal(!isCancelConfirmationModal);
  };
  //When you click on complete the audit session clicking no
  const handleCancelConfirmNoButtonClick = () => {
    toggleCancelConfirmationModal();
  };
  //When you click on complete the audit session clicking yes
  const handleCancelConfirmYesButtonClick = () => {
    updateAuditSession(
      currentStore?.id,
      {
        ...auditSession,
        status: buttonNameConstants.CANCELED,
        completedBy: `${user.firstName} ${user.lastName}`,
        endDate: new Date(),
      },
      buttonNameConstants.CANCELED,
      navigate
    );
  };

  //changing the sort on table
  const onTableSort = (column, sortDirection) => {
    setColumns(
      columns.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );
    setDefaultSortFieldId(column.id);

    setGridState((prev) => ({
      ...prev,
      sortBy: sortDirection
        ? [{ id: column.id, desc: sortDirection === "desc" }]
        : [],
      pageIndex: 0, // reset to first page on sort
    }));
  };

  // changing the nickname clicking edit
  const handleEditNicknameClick = () => {
    setIsEditNickName(true);
  };
  // changing the nickname clicking confirm
  const handleTickNicknameClick = () => {
    updateAuditSession(
      currentStore?.id,
      { ...auditSession, nickName: nickName, notes: notes },
      EMPTY_STRING
    );
    setIsEditNickName(false);
  };
  // changing the nickname clicking cancel
  const handleCrossNicknameClick = () => {
    setIsEditNickName(false);
  };
  // changing the notes clicking edit
  const handleEditNotesClick = () => {
    setIsEditNotes(true);
  };
  // changing the notes clicking confirm
  const handleTickNotesClick = () => {
    updateAuditSession(
      currentStore?.id,
      { ...auditSession, nickName: nickName, notes: notes },
      EMPTY_STRING
    );
    setIsEditNotes(false);
  };
  // changing the notes clicking cancel
  const handleCrossNotesClick = () => {
    setIsEditNotes(false);
  };

  // get all the product types in our table to show in filters
  const getProductTypeOptions = (gridData = []) => {
    const uniqueTypes = [
      ...new Set(gridData.map((item) => item?.productTypeName).filter(Boolean)),
    ];

    return [
      { label: globalConstants.ALL, value: globalConstants.ALL },
      ...uniqueTypes.map((type) => ({
        label: type,
        value: type,
      })),
    ];
  };

  const isLoadingGetStockAuditCategories = isSpinnerEnabled(spinnerArray, [
    inventoryConstants.GET_STOCK_AUDIT_CATEGORIES,
  ]);

  const isLoadingBulkOperation = isSpinnerEnabled(spinnerArray, [
    inventoryConstants.UPDATE_AUDIT_CATEGORY,
  ]);

  const auditedItemsCount =
    gridData.reduce((acc, item) => acc + item.itemsAudited, 0) || 0;

  const totalItemsCount =
    gridData.reduce((acc, item) => acc + item.totalItems, 0) || 0;

  const completedCategoriesCount =
    gridData?.filter((item) => item.status === buttonNameConstants.COMPLETED)
      .length || 0;

  const skeletonArray = Array(10).fill({});
  return (
    <>
      <Topbar
        title="Audit Session"
        backNavigation={{
          isVisible: true,
          route: routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT,
        }}
      ></Topbar>
      {isInitializingAudit ? (
        <>
          <div className="d-flex flex-column justify-content-center align-items-center vh-100">
            <LoadingIndicatorLarge size="lg" />
            <span className="audit-label mt-4">
              Initializing Audit Session.
            </span>
          </div>
        </>
      ) : (
        <>
          <Row className="m-0 border-bottom pb-4">
            <Col md={9}>
              <Row className="m-0">
                <Col md={1} className="mb-3 d-flex align-items-center">
                  <span className="predefinded-audit-label">Nickname</span>
                </Col>
                <Col md={4} className="mb-3">
                  <div className="align-items-center gap-2 w-100">
                    <Row>
                      <Col md={10}>
                        <SimpleInputTextField
                          isDisabled={!isEditNickName}
                          value={nickName}
                          placeHolder="Enter NickName"
                          onChange={(e) => setNickName(e.target.value)}
                          isSmall={true}
                        />
                      </Col>
                      <Col md={2} className="d-flex align-items-center">
                        {isEditNickName ? (
                          <div className=" d-flex gap-2">
                            <button
                              className="action-Button-Wrapper ps-0 pe-0"
                              onClick={() => {
                                handleCrossNicknameClick();
                              }}
                            >
                              <CrossIcon className="cursor-pointer" />
                            </button>
                            <button
                              className="action-Button-Wrapper ps-0 pe-0"
                              onClick={() => {
                                handleTickNicknameClick();
                              }}
                            >
                              <TickIcon className="cursor-pointer text-primary" />
                            </button>
                          </div>
                        ) : (
                          <button
                            className="action-Button-Wrapper ps-0 pe-0"
                            onClick={() => {
                              handleEditNicknameClick();
                            }}
                          >
                            <EditIcon className="cursor-pointer text-muted" />
                          </button>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col md={1} className="mb-3 d-flex align-items-center">
                  <span className="predefinded-audit-label">Status</span>
                </Col>
                <Col md={2} className="mb-3 d-flex align-items-center">
                  <div className="d-flex align-items-center gap-2">
                    <SelectDropDown
                      options={inventoryConstants.STOCK_AUDIT_STATUS_OPTIONS}
                      menuPlacement="bottom"
                      value={inventoryConstants.IN_PROGRESS_STOCK_AUDIT_STATUS}
                      handleChange={(e) => {
                        handleChange(e);
                      }}
                      styles={selectFieldStyleSmall}
                    />
                  </div>
                </Col>
                <Col md={4} className="mb-3 d-flex align-items-center">
                  <span className="predefinded-audit-label">
                    Audit Progress
                  </span>
                </Col>
              </Row>

              <Row className="m-0">
                <Col md={1} className="mb-3 d-flex align-items-center">
                  <span className="predefinded-audit-label">Start Date</span>
                </Col>
                <Col md={4} className="mb-3">
                  <Row className="align-items-center">
                    <Col md={6}>
                      <span>
                        {getReceiptPrintDate(auditSession.startDate, true)}
                      </span>
                    </Col>

                    {/* Duration starting from middle */}
                    <Col md={3} className="d-flex gap-2 align-items-center">
                      <span className="predefinded-audit-label">Duration</span>
                    </Col>
                    <Col md={3} className="d-flex gap-2 align-items-center">
                      <span>
                        {getDurationString(
                          auditSession.startDate,
                          auditSession.endDate
                        )}
                      </span>
                    </Col>
                  </Row>
                </Col>

                <Col md={1} className="mb-3 d-flex align-items-center">
                  <TitleToolTip title={toolTipMessages.STOCK_AUDIT_ITEMS}>
                    <span className="predefinded-audit-label">Total Items</span>
                  </TitleToolTip>
                </Col>
                <Col md={2} className="mb-3 d-flex align-items-center">
                  <span>
                    {parseToThousandSeperatorWholeNumber(
                      auditSession.totalItems || 0
                    )}
                  </span>
                </Col>
                <Col md={1} className="mb-3 d-flex align-items-center">
                  <TitleToolTip title={toolTipMessages.STOCK_AUDIT_ITEMS}>
                    <span className="predefinded-audit-label">Items</span>
                  </TitleToolTip>
                </Col>
                <Col md={3} className="mb-3 d-flex align-items-center">
                  <ProgressBar
                    min={0}
                    max={isLoadingGetStockAuditCategories ? 0 : totalItemsCount}
                    label={
                      isLoadingGetStockAuditCategories
                        ? ""
                        : `${auditedItemsCount} of ${totalItemsCount}`
                    }
                    current={
                      isLoadingGetStockAuditCategories ? "" : auditedItemsCount
                    }
                    percentage={calculateBarWidth(
                      isLoadingGetStockAuditCategories ? 0 : totalItemsCount,
                      isLoadingGetStockAuditCategories ? "" : auditedItemsCount
                    )}
                    barWrapper={true}
                  />
                </Col>
              </Row>
              <Row className="m-0">
                <Col md={1} className="mb-3 d-flex align-items-center">
                  <span className="predefinded-audit-label">Started By</span>
                </Col>
                <Col md={4} className="mb-3 d-flex align-items-center">
                  <span>{auditSession.startedBy}</span>
                </Col>
                <Col md={1} className="mb-3 d-flex align-items-center">
                  <span className="predefinded-audit-label">
                    Total Categories
                  </span>
                </Col>
                <Col md={2} className="mb-3 d-flex align-items-center">
                  <span>{auditSession.totalCategories || 0}</span>
                </Col>
                <Col md={1} className="mb-3 d-flex align-items-center">
                  <span className="predefinded-audit-label">Categories</span>
                </Col>
                <Col md={3} className="mb-3 d-flex align-items-center">
                  <ProgressBar
                    min={0}
                    max={gridData?.length || 0}
                    label={`${completedCategoriesCount || 0} of ${
                      gridData?.length || 0
                    }`}
                    current={completedCategoriesCount}
                    percentage={calculateBarWidth(
                      gridData?.length || 0,
                      completedCategoriesCount
                    )}
                    barWrapper={true}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={3}>
              <Row className="m-0">
                <Col
                  md={12}
                  className="mb-3 d-flex align-items-center justify-content-between"
                >
                  <span className="predefinded-audit-label">Notes</span>
                  {isEditNotes ? (
                    <div className="mt-1 d-flex gap-2">
                      <button
                        className="action-Button-Wrapper ps-0 pe-0"
                        onClick={() => {
                          handleCrossNotesClick();
                        }}
                      >
                        <CrossIcon className="cursor-pointer" />
                      </button>
                      <button
                        className="action-Button-Wrapper ps-0 pe-0"
                        onClick={() => {
                          handleTickNotesClick();
                        }}
                      >
                        <TickIcon className="cursor-pointer text-primary" />
                      </button>
                    </div>
                  ) : (
                    <button
                      className="action-Button-Wrapper ps-0 pe-0"
                      onClick={() => {
                        handleEditNotesClick();
                      }}
                    >
                      <EditIcon className="cursor-pointer text-muted" />
                    </button>
                  )}
                </Col>
              </Row>
              <Row className="m-0">
                <Col md={12} className="d-flex flex-column">
                  <SimpleTextArea
                    isDisabled={!isEditNotes}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeHolder="Enter Notes"
                    maxLength={1000}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="m-0 mb-2 ms-4 mt-4">
            <div className="col-sm-6 px-0 topbar-title-container">
              <span className="audit-label">Audit By Category</span>
            </div>
          </Row>

          <Row className="m-0  p-0 w-100 user-screen-wrapper">
            <Col md={6} className="">
              <SearchField
                onChange={(e) => setSearchText(e.target.value)}
                IconImage={SearchIcon}
                placeHolder="Search Category Name..."
                value={searchText}
                CrossIcon={searchText ? CrossIcon : ""}
                clearSearchText={clearSearchText}
                BlueBoxIcon={BlueBoxIcon}
              />
            </Col>
            <Col md={1} className="justify-content-end align-items-end gap-3">
              <CategoriesDropdown
                options={inventoryConstants.STOCK_AUDIT_FILTER_STATUS_OPTIONS}
                label="Status"
                value={filterStatus}
                handleChange={(selectedOption) => {
                  setFilterStatus(selectedOption || EMPTY_STRING);
                }}
                placeholder="Status"
                isClearable={false}
                wrapperClassname="category-dropdowns-moveup"
                hideIcon={true}
                styles={categoriesDropdownNoIconStyle}
                isSmall={true}
              />
            </Col>
            <Col md={1} className="justify-content-end align-items-end gap-3">
              <CategoriesDropdown
                options={getProductTypeOptions(gridData)}
                label="Type"
                value={filterType}
                handleChange={(selectedOption) => {
                  setFilterType(selectedOption || EMPTY_STRING);
                }}
                placeholder="Type"
                SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
                isClearable={false}
                wrapperClassname="category-dropdowns-moveup"
                isSmall={true}
              />
            </Col>
          </Row>
          <Row className="m-0 w-100 h-100 user-screen-wrapper pt-3">
            {selectedRows.length > 0 && (
              <div className="d-flex justify-content-end mb-2 gap-2">
                <Button
                  label={buttonNameConstants.MARK_AS_COMPLETED}
                  buttonType={buttonTypeConstants.GREEN_BUTTON}
                  type="button"
                  handleClick={handleMarkSelectedAsCompleted}
                  isDisabled={isLoadingBulkOperation}
                  isLoading={isLoadingBulkOperation}
                />
                <Button
                  label={buttonNameConstants.MARK_AS_IN_PROGRESS}
                  buttonType={buttonTypeConstants.BLUE_BUTTON}
                  type="button"
                  handleClick={handleMarkSelectedAsInProgress}
                  isDisabled={isLoadingBulkOperation}
                  isLoading={isLoadingBulkOperation}
                />
              </div>
            )}
            <DataTableComponent
              tableId={TABLE_IDS.STOCK_AUDIT_SESSION}
              key={numOfRenders.current}
              className={`${
                selectedRows.length > 0
                  ? "stock-audit-categories-table-row-selected"
                  : "stock-audit-categories-table"
              }`}
              columns={columns}
              data={
                isLoadingGetStockAuditCategories
                  ? skeletonArray
                  : searchText ||
                    filterStatus.label !== globalConstants.ALL ||
                    filterType.label !== globalConstants.ALL
                  ? handleFilterData()
                  : sortedGridData
              }
              onSort={onTableSort}
              defaultSortFieldId={defaultSortFieldId}
              gridState={gridState}
              setGridState={setGridState}
              total={
                searchText ||
                filterStatus.label !== globalConstants.ALL ||
                filterType.label !== globalConstants.ALL
                  ? handleFilterData().length || 0
                  : sortedGridData?.length || 0
              }
              selectableRows={true}
              handleRowSelectionChange={handleRowSelectionChange}
            />
          </Row>
          <ConfirmationModal
            size={"lg"}
            isConfirmationModal={isCompleteConfirmationModal}
            handleNoButtonClick={handleCompleteConfirmNoButtonClick}
            handleYesButtonClick={
              allCategoriesCompleted
                ? handleCompleteConfirmYesButtonClick
                : handleCompleteConfirmNoButtonClick
            }
            toggleConfirmationModal={toggleCompleteConfirmationModal}
            isLoading={isSpinnerEnabled(spinnerArray, [
              inventoryConstants.UPDATE_AUDIT_SESSION,
            ])}
            noButtonText={buttonNameConstants.CANCEL}
            yesButtonText={
              allCategoriesCompleted
                ? buttonNameConstants.CONFIRM
                : buttonNameConstants.CANCEL
            }
            isHtmlMessage={true}
            message={
              allCategoriesCompleted
                ? isShopifyConnected(currentStore)
                  ? getConfirmAuditCompletionHtmlShopify()
                  : getConfirmAuditCompletionHtml()
                : getConfirmAuditCompletionIncompleteHtml(
                    gridData?.length || 0,
                    completedCategoriesCount
                  )
            }
            isNoButton={allCategoriesCompleted}
            title={
              allCategoriesCompleted
                ? getConfirmAuditCompletionHtmlTitle()
                : getConfirmAuditCompletionIncompleteHtmlTitle()
            }
          />
          <ConfirmationModal
            isConfirmationModal={isCancelConfirmationModal}
            handleNoButtonClick={handleCancelConfirmNoButtonClick}
            handleYesButtonClick={handleCancelConfirmYesButtonClick}
            toggleConfirmationModal={toggleCancelConfirmationModal}
            message={
              "Are you sure you want to mark this Audit Session as Canceled?"
            }
            isLoading={isSpinnerEnabled(spinnerArray, [
              inventoryConstants.UPDATE_AUDIT_SESSION,
            ])}
          />
          <ConfirmationModal
            size={"lg"}
            isConfirmationModal={isBulkCompleteConfirmationModal}
            handleNoButtonClick={handleBulkCompleteConfirmNoButtonClick}
            handleYesButtonClick={() => {
              setBulkUncountedAction(buttonNameConstants.ZERO_ITEMS);
              toggleBulkCompleteConfirmationModal();
              toggleBulkConfirmCompleteModal();
            }}
            handleDiscardButtonClick={() => {
              setBulkUncountedAction(buttonNameConstants.IGNORE_ITEMS);
              toggleBulkCompleteConfirmationModal();
              toggleBulkConfirmCompleteModal();
            }}
            toggleConfirmationModal={toggleBulkCompleteConfirmationModal}
            isDiscardButton={true}
            isLoading={isLoadingBulkOperation}
            noButtonText={buttonNameConstants.CANCEL}
            yesButtonText={buttonNameConstants.ZERO_ITEMS}
            discardButtonText={buttonNameConstants.IGNORE_ITEMS}
            yesButtonType={buttonTypeConstants.RED_BUTTON_FILL}
            isHtmlMessage={true}
            message={getConfirmCategoryCompletionIncompleteHtml(
              selectedRows.length,
              selectedRows.reduce((sum, row) => sum + (row.totalItems || 0), 0),
              selectedRows.reduce(
                (sum, row) => sum + (row.itemsAudited || 0),
                0
              )
            )}
            title={getConfirmCategoryCompletionIncompleteHtmlTitle(
              selectedRows.length
            )}
          />
          <ConfirmationModal
            isConfirmationModal={isBulkConfirmCompleteModal}
            handleNoButtonClick={handleBulkConfirmCompleteNoButtonClick}
            handleYesButtonClick={handleBulkConfirmCompleteYesButtonClick}
            toggleConfirmationModal={toggleBulkConfirmCompleteModal}
            noButtonText={buttonNameConstants.CANCEL}
            yesButtonText={buttonNameConstants.COMPLETE}
            isHtmlMessage={true}
            message={getConfirmCategoryCompletionHtml()}
            isLoading={isLoadingBulkOperation}
            title={getConfirmCategoryCompletionHtmlTitle()}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  spinnerArray: state.system.spinnerArray,
  stockAuditCategoryList: state.inventory.stockAuditCategoryList,
  currentStore: state.store.currentStore,
  stockAudit: state.inventory.stockAudit,
  user: state.authentication.user,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getStockAuditCategories: (storeId, auditId) =>
    dispatch(inventoryActions.getStockAuditCategories(storeId, auditId)),
  updateAuditSession: (storeId, data, status, navigate) =>
    dispatch(
      inventoryActions.updateAuditSession(storeId, data, status, navigate)
    ),
  updateStockAuditCategory: (...args) =>
    dispatch(inventoryActions.updateStockAuditCategory(...args)),
});

//-------Export AddInvoice Component
export default connect(mapStateToProps, mapDispatchToProps)(StockAuditSession);
